module.exports = __webpack_public_path__ + "img/buddy_antenna-02.30a62aec.svg";